import { duckChangeLibras } from 'store/ducks/app';
import { fetchNotificationDebug } from 'store/fetchActions/fetchApp';

// HOME
export const altImageHome =
  'Uma ilustração em 2D de uma mulher branca, camisa amarela e cabelo escuro, segurando um celular e na sua frente um notebook. Em segundo plano uma imagem em 2D de um celular com o site do FAS aberto.';
export const altImageSefaz = 'Imagem de um texto escrito SEFAZ Secretaria Municipal da Fazenda';

// HOME PUBLIC
export const altImagemBemVindo =
  'Uma ilustração em 2D de três pessoas em volta de um requerimento, as três pessoas (duas mulheres e um homem) estão com camisa azul e calça preta.';
export const altImagemProtocolo =
  'Uma ilustração em 2D com duas pessoas em frente ao monitor, com uma lupa, verificando pastas de requerimentos.';
export const altLogoIconeSefaz =
  'Logotipo da Prefeitura Municipal de Salvador, ilustrando uma pomba branca ao meio e um texto em latim com a seguinte frase: sic est illa ad arcam reversa';

export const altIconeTema = ativo => (ativo ? 'Imagem de um sol' : 'Imagem de uma lua');
export const altIconePaleta = 'Ícone ilustrando uma paleta a direita e um pincel a esquerda';
export const altIconeContraste =
  'Ícone representando alto contraste, círculo com metade pintada da preto ou amarelo e outra metade mostrando o cor atual de fundo do sistema';

export const altImageAtendente =
  'Uma ilustração 2D com uma mulher sentada com um laptop a direita e a ficha cadastral de três pessoas flutuando a esquerda';
export const altImageServico =
  'Uma ilustração 2D mostrando uma listagem de serviços, escrito Serviço faz em seu título e mostrando no resultado da busca 5 serviços on os 22 primeiros possuem 5 estrelas e os últimos 3 possuem 4 estrelas';
export const altImageSetor =
  'Uma ilustração 2D mostrando uma janela com vista para prédios a direita e a esquerda um relógio de ponteiro acima de um quadro de avisos com alguns papéis e um vaso de planta no chão';
export const altImageDuvida =
  'Uma ilustração 2D mostrando uma mulher com expressão de dúvida e interrogações flutuando ao redor dela';
export const altImageAtendimento =
  'Uma ilustração 2D com duas pessoas sentadas, cada uma com seu laptop e com fones de ouvido, balões de conversa representando um atendimento sendo feito e um relógio de ponteiro no meio dos dois';
export const altImageNotFound =
  'Uma ilustração 2D mostrando uma pasta com um rosto triste, arquivos quebrados flutuando e a frente uma tomada sendo desconectada';
export const altImagePostosAtendimento =
  'Uma ilustração 2D mostrando um mapa onde são indicados localizações de postos de atendimento com um indicador de localização vermelho';

const qtdElementVwInPage = 3;

export const openVlibras = () => {
  try {
    document.getElementById('autoClickOpenLibras').dispatchEvent(new Event('click'));
  } catch (error) {
    fetchNotificationDebug(`Erro na Função openVlibras: ${error}`);
  }
};

export const closeVlibras = () => {
  try {
    const buttonClose = document.getElementsByClassName('vpw-header-btn-close');
    if (buttonClose?.length > 0) {
      buttonClose[0].click();
    }
  } catch (error) {
    fetchNotificationDebug(`Erro na Função closeVlibras: ${error}`);
  }
};

export const reloadVlibras = () => {
  try {
    //verifica se o vlibras está aberto e o fecha e abre novamente caso esteja
    if (document.querySelector('[vw-plugin-wrapper]').classList.contains('active')) {
      document.querySelector('.vpw-header-btn-close').dispatchEvent(new Event('click'));
      document.getElementById('autoClickOpenLibras').dispatchEvent(new Event('click'));
    }
  } catch (error) {
    fetchNotificationDebug(`Erro na Função reloadVlibras: ${error}`);
  }
};

export const VLibrasIsOpen = () => {
  try {
    const elementVw = document.getElementsByClassName('vw-text');
    return elementVw && elementVw?.length > qtdElementVwInPage ? true : false;
  } catch (error) {
    fetchNotificationDebug(`Erro na Função VLibrasIsOpen: ${error}`);
  }
};

export const saveChangeLibras = () => dispatch => {
  try {
    const close = () => {
      dispatch(duckChangeLibras(false));
    };
    const open = () => {
      dispatch(duckChangeLibras(true));
      let buttonClose = document.querySelector('.vpw-header-btn-close');

      if (!buttonClose) {
        const observer = new MutationObserver((mutationsList, observer) => {
          buttonClose = document.querySelector('.vpw-header-btn-close');
          if (buttonClose) {
            observer.disconnect();
            buttonClose.onclick = close;
          }
        });
        observer.observe(document.querySelector('[vw-plugin-wrapper]'), { childList: true, subtree: true });
        return;
      }

      buttonClose.onclick = close;
    };
    const buttonOpen = document.querySelector('#autoClickOpenLibras');
    if (buttonOpen) {
      buttonOpen.onclick = open;
    }
  } catch (error) {
    fetchNotificationDebug(`Erro na Função saveChangeLibras: ${error}`);
  }
};

export const changeShowLibras = status => {
  const display = status ? '' : 'none';
  try {
    document.getElementsByClassName('enabled')[0].style.display = display;
  } catch (error) {
    fetchNotificationDebug(`Erro na Função changeShowLibras: ${error}`);
  }
  return display;
};
